<template>
    <b-card no-body class="square-card">
      <b-card-body class="d-flex align-items-center p-5">
        <b-avatar :variant="`light-${color}`" size="100" class="mr-2">
          <component :is="iconComponent" :svgColor="colorHex" :width="width" />
        </b-avatar>
        <div class="truncate">
          <h4 class="mb-25 font-weight-bolder">{{ statistic }}</h4>
          <span>{{ statisticTitle }}</span>
        </div>
      </b-card-body>
    </b-card>
  </template>
  
  <script>
  import { BCard, BCardBody, BAvatar } from 'bootstrap-vue';
  
  export default {
    components: {
      BCard,
      BCardBody,
      BAvatar,
    },
    props: {
      iconComponent: {
        type: Object,
        required: true,
      },
      statistic: {
        type: [Number, String],
        required: true,
      },
      statisticTitle: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'primary',
      },
      colorHex: {
        type: String,
      },
      width: {
        type: String,
      },
    },
  };
  </script>
  
  <style scoped>
  .square-card {
    width: 100%;
    height: 200px;
  }
  </style>